/**
 * ProLayout 默认配置
 * 参考：pro-components/src/layout/defaultSettings.ts
 */

import type { ProSettings } from './typing';

/**
 * 默认布局配置
 */
export const defaultSettings: ProSettings = {
  /** 侧边栏宽度 */
  siderWidth: 244,
  /** 收起时侧边栏宽度 */
  collapsedWidth: 80,
  /** 固定头部 */
  fixedHeader: true,
  /** 固定侧边栏 */
  fixSiderbar: true,
};

/**
 * 默认页签配置
 */
export const defaultTabsSettings = {
  /** 最大页签数量 */
  maxTabs: 15,
  /** 首页路径（undefined 表示自动从 routes 中取第一个） */
  homePath: undefined as string | undefined,
};
